import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Link, Skeleton, Text } from '@hopskipdrive/react-components';

import { ContactCard } from '../../../../shared/components/ContactCard';
import { CopyToClipboard } from '../../../../shared/components/CopyToClipboard';
import { SchoolBuildingIcon } from '../../../../shared/components/Icons';
import { colorTokens } from '../../../../shared/components/variables';
import { ExpandableNotesContainer } from '../../../components/ExpandableNotesContainer';
import { useRideDetailsQuery } from '../../../hooks/useRideDetailsQuery';

import { Heading } from './index';

interface AccountNotesProps {
  id: string;
  state: 'default' | 'maximized' | 'minimized';
  onClick: () => void;
}

export const AccountNotes: FC<AccountNotesProps> = ({ id, state, onClick }) => {
  const { rideSlug } = useParams();
  const { data: rideDetailsResult, isFetching } = useRideDetailsQuery({ rideSlug: rideSlug || '' });

  return (
    <ExpandableNotesContainer id={id} state={state} style={{ padding: '12px' }}>
      <Box mb={1} sx={{ width: '100%' }}>
        <Heading id={id} state={state} onClick={onClick} />
      </Box>
      {isFetching ? (
        <Skeleton data-testid="account-notes-skeleton" variant="text" width={600} height={32} />
      ) : (
        <ContactCard color={colorTokens.info.main}>
          <ContactCard.Title>
            <SchoolBuildingIcon
              style={{
                display: 'block',
                height: '24px',
                width: '24px',
                alignSelf: 'center',
                color: colorTokens.primary.main,
              }}
            />
            <Link
              target="_blank"
              variant="h6"
              underline="hover"
              href={rideDetailsResult?.data?.accountDetails.accountUrl}
              style={{ color: colorTokens.primary.main, fontWeight: 500 }}
            >
              {`Account: ${rideDetailsResult?.data?.accountDetails.accountName}`}
            </Link>
            <CopyToClipboard
              toastMessage="Slug Copied"
              text={rideDetailsResult?.data?.accountDetails.accountSlug}
              variant="h6"
              color={colorTokens.text.secondary}
            />
          </ContactCard.Title>
        </ContactCard>
      )}
      <Box mt={3} overflow="auto" sx={{ width: '100%' }}>
        {isFetching ? (
          <Skeleton data-testid="account-notes-skeleton" variant="text" width={650} height={100} />
        ) : (
          <Text variant="body1" textColor="secondaryText" fontWeight={400} sx={{ whiteSpace: 'pre-line' }}>
            {rideDetailsResult?.data?.accountDetails.accountNotes}
          </Text>
        )}
      </Box>
    </ExpandableNotesContainer>
  );
};
